module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"published":"Published","definition":"Definition"}}}')
  delete Component.options._Ctor
}
